/**
 * Eldrazi Titans horde deck.
 * Source: hordemagic.com (~290 cards: 150 tokens / ~140 nontoken).
 * Scaled to ~100 cards preserving the ~1:1 token:nontoken ratio.
 * All nontoken card names verified against local card DB, including starred entries:
 *   - "Eldrazi Ravager" ✓ (exists)
 *   - "Hideous Taskmaster" ✓ (exists)
 *   - "Titans' Vanguard" ✓ (exists)
 *   - "Twins of Discord" ✓ (exists)
 * Token: "Eldrazi Scion" (10e69ee5) — real Scryfall printing.
 */
export const eldraziDeck = {
    id: 'eldrazi',
    name: 'Eldrazi Invasion',
    description: 'Ancient titans and their numberless spawn consume all mana and life in their path.',
    cards: [
        // ── Tokens (52 Eldrazi Scion) ────────────────────────────────────────────
        { name: 'Eldrazi Scion', quantity: 52, isToken: true, scryfallId: '10e69ee5-ea72-4f0b-91fe-152b1459e318' },
        // ── Titan Bosses (8, 1x each) ────────────────────────────────────────────
        { name: 'Emrakul, the Aeons Torn', quantity: 1, isToken: false },
        { name: 'Emrakul, the World Anew', quantity: 1, isToken: false },
        { name: 'Kozilek, Butcher of Truth', quantity: 1, isToken: false },
        { name: 'Kozilek, the Broken Reality', quantity: 1, isToken: false },
        { name: 'Kozilek, the Great Distortion', quantity: 1, isToken: false },
        { name: 'Ulamog, the Ceaseless Hunger', quantity: 1, isToken: false },
        { name: 'Ulamog, the Defiler', quantity: 1, isToken: false },
        { name: 'Ulamog, the Infinite Gyre', quantity: 1, isToken: false },
        // ── Eldrazi Creatures (30) ───────────────────────────────────────────────
        { name: 'Eldrazi Skyspawner', quantity: 2, isToken: false },
        { name: 'Eldrazi Devastator', quantity: 1, isToken: false },
        { name: "Ulamog's Crusher", quantity: 3, isToken: false },
        { name: 'Artisan of Kozilek', quantity: 2, isToken: false },
        { name: 'Bane of Bala Ged', quantity: 2, isToken: false },
        { name: 'Birthing Hulk', quantity: 2, isToken: false },
        { name: 'Breaker of Armies', quantity: 1, isToken: false },
        { name: 'Decimator of the Provinces', quantity: 1, isToken: false },
        { name: 'Desolation Twin', quantity: 3, isToken: false },
        { name: 'Eldrazi Ravager', quantity: 1, isToken: false },
        { name: 'Flayer Drone', quantity: 2, isToken: false },
        { name: 'Hideous Taskmaster', quantity: 1, isToken: false },
        { name: 'It That Betrays', quantity: 1, isToken: false },
        { name: 'Pathrazer of Ulamog', quantity: 1, isToken: false },
        { name: 'Reality Smasher', quantity: 2, isToken: false },
        { name: 'Sire of Stagnation', quantity: 1, isToken: false },
        { name: "Titans' Vanguard", quantity: 1, isToken: false },
        { name: 'Twins of Discord', quantity: 1, isToken: false },
        { name: 'Vile Aggregate', quantity: 2, isToken: false },
        { name: 'Void Winnower', quantity: 1, isToken: false },
        { name: 'World Breaker', quantity: 1, isToken: false },
        // ── Spells (5) ───────────────────────────────────────────────────────────
        { name: 'All Is Dust', quantity: 2, isToken: false },
        { name: 'Extinction Event', quantity: 1, isToken: false },
        { name: 'Overrun', quantity: 1, isToken: false },
        { name: 'Overwhelming Stampede', quantity: 1, isToken: false },
        // ── Artifacts & Enchantments (5) ─────────────────────────────────────────
        { name: 'Eldrazi Monument', quantity: 2, isToken: false },
        { name: 'Eldrazi Conscription', quantity: 1, isToken: false },
        { name: 'Everlasting Torment', quantity: 1, isToken: false },
        { name: 'Molten Nursery', quantity: 1, isToken: false },
    ],
};
//# sourceMappingURL=eldrazi.js.map